const createState = {
  user: null,
  authLoad: true,
  authed: false,
  isLoaded: false,
  screen: "laptop",
  kycOpen: false,
  reminderOpen: false,
  downloadAppOpen: false,
  mainLoading: true,
  iqamaAlert: false,
  policyVerificationOpen: false,
  modals: {
    default: false,
    addAccountOpen: false,
    addStatementOpen: false,
    ehsanConfirm: {
      isOpen: false,
      data: null,
    },
    deleteError: false,
    logoutOpen: false,
    commentOpen: false,
    termsOpen: false,
    surveyOpen: false,
    deletePopOpen: false,
    adsInOpen: false,
    cookiesSettingsOpen: false,
    suitability: { isOpen: false, suitable: false },
    successModal: {
      isOpen: false,
      type: undefined,
    },
  },
  fundTermsOpen: false,
  notifications: {
    items: [],
    loading: false,
    hasMore: false,
  },
  homeFunds: {
    items: [],
    loading: false,
    hasMore: false,
  },
  homeFundsSearch: {
    items: [],
    loading: false,
    hasMore: false,
  },
  transactions: {
    items: [],
    loading: false,
    hasMore: false,
  },
  myInvestment: {
    items: [],
    loading: false,
    hasMore: false,
    itemsLoading: false,
    investmentsParams: { cancel_statistic: "0" },
  },
  faq: {
    items: [],
    loading: false,
    loadingMore: false,
    hasMore: false,
  },
  bankAccounts: {
    items: [],
    loading: true,
    loadingMore: false,
    hasMore: false,
  },
  approvedAccounts: {
    items: [],
    loading: true,
    loadingMore: false,
    hasMore: false,
  },
  ehsanAccounts: {
    items: [],
    loading: true,
    loadingMore: false,
    hasMore: false,
  },
  professionalRequests: {
    items: [],
    loading: true,
    loadingMore: false,
    hasMore: false,
  },
};

export default createState;
